import store from '@/store/index.js'
import { getRelevantUrlComponent } from './ApiHelpers.js'
import { outboundRequests } from '@/utils/api/Interceptor.js'

export const responseHandler = (response) => {
  const { config } = response
  delete outboundRequests[config.url]

  if (shouldSnack(config)) {
    store.dispatch('snackbar/setSnack', getSnackMessageForResponse(config))
  }

  store.dispatch('global/setLoading', false)
  return response
}

const shouldSnack = ({ url, method }) => {
  return method !== 'get' && method !== 'patch' &&
    !url.toLowerCase().includes('userpreferences') &&
    !(url.toLowerCase().includes('postbatches') && url.toLowerCase().includes('tickets'))
}

const getSnackMessageForResponse = ({ url, method }) => {
  const resourceName = getRelevantUrlComponent(url)

  if (resourceName === 'user preferences') return

  // EUDR routes are multi-segment (…/eudr/{id}/send), so their last segments are generic words
  // like "upload"; matching the full URL keeps those keys scoped to this feature instead of claiming
  // the names app-wide. Routes absent from the map (send, filerequest) snack from their own dialogs.
  if (url.toLowerCase().includes('eudr')) return eudrResponses[resourceName]?.[method]

  if (customResponses[resourceName]) return customResponses[resourceName][method]

  switch (method) {
    case 'put': return `Updated ${resourceName} successfully!`
    case 'delete': return `Deleted ${resourceName} successfully!`
    case 'post': return `Created ${resourceName} successfully!`
  }
}

const customResponses = {
  'consumption group': {
    post: 'Inventory consumption successful!',
    delete: 'Consumption reverted successfully!'
  },
  'posting group': {
    post: 'Selected tickets posted successfully!',
    delete: 'Select tickets have been unposted successfully!'
  },
  transferbatche: {
    post: 'Inventory transfer successful!'
  },
  deckadjustment: {
    post: 'Deck adjustment created successfully!',
    delete: 'Deck adjustment deleted successfully!'
  },
  adjustingentrie: {
    post: 'Adjusting Entries creation process is underway, please refresh shortly!'
  },
  userclaim: {
    post: 'Modified role assignment successfully!'
  },
  contractapproval: {
    post: 'Created contract approval successfully!',
    put: 'Updated contract approval successfully!'
  },
  tractlandowner: {
    post: 'Allocated landownership successfully!',
    delete: 'Removed landownership successfully!'
  },
  templatebundle: {
    post: 'Created template bundle successfully!',
    put: 'Updated template bundle successfully!',
    delete: 'Deleted template bundle successfully'
  },
  emailrequest: {
    post: 'Scheduled settlement email successfully!'
  },
  rebuildarchive: {
    post: 'Archiving export batch data, please refresh shortly!'
  },
  synctag: {
    post: 'Requested Product and Destination Tag Synchronization, please refresh shortly!'
  }
}

// Only consulted for eudr URLs; keyed on the last URL segment (see getRelevantUrlComponent).
const eudrResponses = {
  eudr: {
    delete: 'EUDR package deleted successfully!'
  },
  upload: {
    post: 'External EUDR file attached successfully!'
  },
  composite: {
    post: 'Geolocation file generation started, please refresh shortly!'
  },
  // PUT eudr/{id} covers both validate and finalize, which this URL-keyed map cannot tell apart —
  // the validation dialog snacks those itself.
  validation: {
    delete: 'EUDR validation reset successfully!'
  }
}
